/* ==========================================================================
   VASUMATIS — COLLECTION SIDEBAR
   Save as  assets/vasumatis-sidebar.js  and load it from theme.liquid,
   next to the card script:

       {{ 'vasumatis-sidebar.js' | asset_url | script_tag }}

   Two behaviours the CSS cannot do on its own.

   1 · Click anywhere on a group row to open it, not only the small +.
       Avone binds its toggle to the <i> glyph alone, which is a ~15px
       target — fine with a mouse, poor with a thumb.

   2 · A sticky Clear / View results bar at the foot of the mobile drawer.
       The theme filters instantly, so once you tap a colour the results
       have already changed behind the drawer with nothing telling you so,
       and no way out but the small × at the top.

   Neither touches the theme's own handlers; this only forwards a click and
   appends an element.
   ========================================================================== */

(function () {
  'use strict';

  /* ======================================================================
     1 · THE GROUP TOGGLE — owned here, not forwarded

     v1 forwarded a row click to Avone's own icon handler. That worked on a
     fresh page load and then stopped after any filter was applied.

     The reason: Avone binds the toggle directly to each <i> at load, and its
     ajax filter (the colour swatches and the tag URLs) re-renders the sidebar
     markup. The new icons come back with no handler attached, so the theme's
     toggle is dead and forwarding to it did nothing. Reproduced on
     /collections/kanjivaram-sarees: tick a colour, then no group would open,
     by icon OR by row.

     So this owns the toggle outright. Delegated on document, so it survives
     any number of ajax re-renders; capture phase with stopPropagation, so on
     a fresh load the theme's own handler cannot also fire and undo it.

     A top-level item with no children (Luxe Sarees) has no <ul>, so it falls
     through untouched and navigates.
     ====================================================================== */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var row = e.target.closest('.sidebar_cate > li.lvl-1 > a.site-nav');
    if (!row) return;

    var li = row.parentElement;
    var ul = li && li.querySelector(':scope > ul.subLinks');
    if (!ul) return;                 // childless link — let it navigate

    e.preventDefault();              // the row's href is "#"
    e.stopPropagation();             // and the theme must not double-toggle

    ul.style.display = (ul.style.display === 'block') ? 'none' : 'block';
  }, true);

  /* ======================================================================
     2 · STICKY ACTION BAR IN THE MOBILE DRAWER
     ====================================================================== */
  function productCount() {
    var el = document.querySelector('.filters-toolbar__product-count');
    if (!el) return null;
    var m = (el.textContent || '').match(/of\s+([\d,]+)/i);
    return m ? m[1] : null;
  }

  function buildBar() {
    var sb = document.querySelector('.sidebar.filterbar');
    if (!sb) return;

    var bar = sb.querySelector('.vas-fbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'vas-fbar';
      bar.innerHTML =
        '<button type="button" class="vf-clear">Clear</button>' +
        '<button type="button" class="vf-done">View results</button>';
      sb.appendChild(bar);

      // close the drawer — the filtering has already happened
      bar.querySelector('.vf-done').addEventListener('click', function () {
        sb.classList.remove('active');
      });

      // back to the bare collection: drops the /tag path AND the ?filter params
      bar.querySelector('.vf-clear').addEventListener('click', function () {
        var m = location.pathname.match(/^(\/collections\/[^\/]+)/);
        location.href = m ? m[1] : location.pathname;
      });
    }

    var n = productCount();
    bar.querySelector('.vf-done').textContent = n ? 'View ' + n + ' sarees' : 'View results';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildBar);
  } else {
    buildBar();
  }

  /* The count changes when a filter is applied, because the theme swaps the
     product grid over ajax. Watch the toolbar and relabel the button. */
  function watchCount() {
    var el = document.querySelector('.filters-toolbar__product-count');
    if (!el) return false;
    new MutationObserver(buildBar).observe(el, {
      childList: true, subtree: true, characterData: true
    });
    return true;
  }
  if (!watchCount()) {
    document.addEventListener('DOMContentLoaded', watchCount);
  }
  /* ==========================================================================
     MOBILE DRAWER — make the whole row open the section

     The theme binds its accordion to the little <i> only, so a tap anywhere
     else on SAREES or Shop by Weave did nothing. The sidebar has always
     opened on the whole row, so the drawer felt broken by comparison.

     A toggle row is an <a href="#"> that contains an <i>. A destination row —
     NEW ARRIVALS, LUXE, TRACK ORDER, and every collection link — has a real
     href and no <i>, so it never matches and keeps navigating normally.

     Capture phase, and scoped to #MobileNav, so nothing on the desktop mega
     menu is touched even though it shares the .siteNavigation class.
     ========================================================================== */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var a = t.closest('#MobileNav a[href="#"]');
    if (!a) return;

    var i = a.querySelector('i');
    if (!i) return;      // not a toggle row
    if (t === i) return; // the icon already works; let it through

    e.preventDefault();  // otherwise the "#" jumps the page to the top
    i.click();
  }, true);
})();

/* ═══════════ STICKY CART — save, add, buy ═══════════
   Append to the end of assets/vasumatis-sidebar.js                   */

(function () {

  /* Avone keeps the wishlist in localStorage as "+handle+handle" */
  var WL = 'wishlist';
  function wlList(){ return (localStorage.getItem(WL) || '').split('+').filter(Boolean); }
  function wlHas(h){ return wlList().indexOf(h) > -1; }
  function wlToggle(h){
    var a = wlList(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.push(h);
    try { localStorage.setItem(WL, a.length ? '+' + a.join('+') : ''); } catch (e) {}
    var badge = document.querySelector('.hdicon.wishlist span, .hdicon.wishlist .count');
    if (badge) badge.textContent = a.length;
    return i === -1;
  }

  function build() {
    var bar = document.querySelector('.stickyCart');
    if (!bar || bar.dataset.vsDone) return;
    var add = bar.querySelector('.stAddtocart_js');
    if (!add) return;
    bar.dataset.vsDone = '1';

    var row  = add.parentNode;
    var root = document.querySelector('product-info.product-single__meta') ||
               document.querySelector('product-info');
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];

    /* ── relabel the theme's button ── */
    (add.querySelector('span') || add).textContent = 'Add to bag';

    /* ── heart ── */
    if (handle) {
      var wish = document.createElement('button');
      wish.type = 'button';
      wish.className = 'vsWish';
      wish.setAttribute('aria-label', 'Save for later');
      wish.innerHTML = '<i class="at at-heart-l" aria-hidden="true"></i>';
      wish.classList.toggle('is-active', wlHas(handle));
      wish.addEventListener('click', function (e) {
        e.preventDefault();
        wish.classList.toggle('is-active', wlToggle(handle));
      });
      row.insertBefore(wish, add);
    }

    /* ── buy now ──
       Razorpay Magic Checkout does not intercept /checkout. It binds to the
       theme's own button[name="checkout"], so the sequence is: add to cart,
       click that button, and fall back to /checkout if no modal appears. */
    var buy = document.createElement('button');
    buy.type = 'button';
    buy.className = 'vsBuy';
    buy.textContent = 'Buy now';
    buy.addEventListener('click', function () {
      var scope = root || document;
      var idEl  = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      var id    = idEl && idEl.value;
      var qEl   = document.getElementById('stquantity');
      var q     = (qEl && parseInt(qEl.value, 10)) || 1;
      if (!id) { location.href = '/cart'; return; }

      buy.disabled = true;
      buy.textContent = 'Adding…';
      var reset = function () { buy.disabled = false; buy.textContent = 'Buy now'; };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: q }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');

          var co = document.querySelector('button[name="checkout"], [name="checkout"]');
          if (!co) { location.href = '/checkout'; return; }

          co.click();

          /* The modal is position:fixed, so offsetParent is null even when it
             is open. Closed it is display:none with zero height; open it is
             display:block and full height. Poll for up to 6s. */
          var waited = 0;
          var poll = setInterval(function () {
            var m  = document.querySelector('.razorpay-container');
            var cs = m && getComputedStyle(m);
            var open = !!(cs && cs.display !== 'none' &&
                          m.getBoundingClientRect().height > 0);

            if (open) { clearInterval(poll); reset(); return; }

            waited += 200;
            if (waited >= 6000) {
              clearInterval(poll);
              reset();
              location.href = '/checkout';
            }
          }, 200);
        })
        .catch(reset);
    });
    row.insertBefore(buy, add.nextSibling);

    /* ── price, read from the MAIN product, not a card ──
       cards use .priceWraper / .pr_price, the product page uses .psinglePrice */
    var title = bar.querySelector('.sticky-title');
    if (root && title) {
      var box = document.createElement('div');
      box.className = 'vsPrice';

      var sync = function () {
        var reg  = root.querySelector('s.psinglePrice');
        var sale = root.querySelector('.psinglePrice.sale') ||
                   root.querySelector('.psinglePrice:not(s)');
        if (!sale) { box.textContent = ''; return; }
        box.innerHTML = '';
        if (reg) {
          var s = document.createElement('s');
          s.textContent = reg.textContent.trim();
          box.appendChild(s);
        }
        var n = document.createElement('span');
        n.className = 'vsNow';
        n.textContent = sale.textContent.trim();
        box.appendChild(n);
      };

      sync();
      try {
        new MutationObserver(sync).observe(root,
          { childList: true, subtree: true, characterData: true });
      } catch (e) {}

      title.parentNode.insertBefore(box, title.nextSibling);
    }

    /* ── visibility, with a dead zone ──
       The theme shows and hides the bar on a single scroll threshold. On a
       phone the URL bar collapsing and expanding changes viewport height and
       scroll offset, so that threshold is crossed repeatedly and the bar
       flickers. Two thresholds 260px apart make that impossible. */
    var pinned = false, ticking = false;

    bar.classList.add('vsUnpinned');   /* only now does the script own it */

    /* Thresholds are measured from the page's own Add to cart button rather
       than fixed pixels, so they hold on every product and screen size:
       show once it has scrolled well past, hide as it comes back into reach.
       The 260px between them is the dead zone that stops the flicker. */
    function anchorY() {
      var b = document.querySelector(
        'product-info.product-single__meta .product-form__submit, ' +
        'product-info .product-form__submit');
      if (b) {
        var r = b.getBoundingClientRect();
        return r.top + (window.pageYOffset || document.documentElement.scrollTop || 0) + r.height;
      }
      return 720;   /* fallback if the theme markup ever changes */
    }
    /* Tune these two. SHOW_AFTER is how far past the Add to cart button you
       must scroll before the bar arrives — lower it to make it appear sooner.
       Keep at least 150px between the two or the bar can flicker. */
    var SHOW_AFTER  = 40;    /* px past the button   */
    var HIDE_BEFORE = 140;   /* px before it         */

    var SHOW = 0, HIDE = 0;
    function measure() {
      var a = anchorY();
      SHOW = a + SHOW_AFTER;
      HIDE = a - HIDE_BEFORE;
    }
    measure();

    function scrollY() {
      return window.pageYOffset ||
             document.documentElement.scrollTop ||
             document.body.scrollTop || 0;
    }

    function check() {
      ticking = false;
      var y = scrollY();
      if (!pinned && y > SHOW) {
        pinned = true;
        bar.classList.remove('vsUnpinned');
        bar.classList.add('vsPinned');
      } else if (pinned && y < HIDE) {
        pinned = false;
        bar.classList.remove('vsPinned');
        bar.classList.add('vsUnpinned');
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }

    /* body carries overflow:auto on this theme, so the scroll event does not
       always reach window. Listen on all three, and keep a slow poll as a
       backstop — it costs nothing and cannot be suppressed by other scripts. */
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    document.body.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); });
    window.addEventListener('orientationchange', function () {
      setTimeout(function () { measure(); onScroll(); }, 250);
    });
    setInterval(check, 250);

    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();

/* ═══════════ CART DRAWER ═══════════
   Append to the end of assets/vasumatis-sidebar.js
   (JavaScript only — the stylesheet goes in assets/custom.css)

   Every step below checks for its own result before acting, so this can
   run after each of Avone's re-renders without duplicating anything and
   without a one-shot flag that would block re-application.             */

(function () {

  var productCache = {};
  var painting = false;

  function inr(paise) {
    return '₹ ' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  var ICON = {
    ship: '<path d="M1 6h13v10H1z"/><path d="M14 9h4l3 3.2V16h-7z"/><circle cx="6" cy="18.5" r="1.9"/><circle cx="17" cy="18.5" r="1.9"/>',
    lock: '<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/>',
    back: '<path d="M3 12a9 9 0 109-9"/><path d="M3 4v5h5"/>',
    swap: '<path d="M17 3l4 4-4 4"/><path d="M21 7H8a4 4 0 00-4 4v1"/><path d="M7 21l-4-4 4-4"/><path d="M3 17h13a4 4 0 004-4v-1"/>'
  };
  function svg(k) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICON[k] + '</svg>'; }

  /* compare-at prices are not in /cart.js, so read them per product */
  function compareAt(handle, variantId) {
    if (productCache[handle]) return Promise.resolve(pick(productCache[handle], variantId));
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return pick(p, variantId); })
      .catch(function () { return 0; });
  }
  function pick(p, id) {
    if (!p || !p.variants) return 0;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === id) return p.variants[i].compare_at_price || 0;
    }
    return 0;
  }

  function paint(inner) {
    if (painting) return;
    var needsTotals = !inner.querySelector('.vcRow');
    var needsLines  = !!inner.querySelector('.ctitempr:not(.vcDone)');
    if (!needsTotals && !needsLines) return;

    painting = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        return Promise.all(cart.items.map(function (it) {
          return compareAt(it.handle, it.variant_id);
        })).then(function (cmps) {

          var rows = inner.querySelectorAll('li.cart-item');
          var mrp = 0;

          cart.items.forEach(function (it, i) {
            var was = (cmps[i] && cmps[i] > it.price) ? cmps[i] : it.price;
            mrp += was * it.quantity;

            var box = rows[i] && rows[i].querySelector('.ctitempr');
            if (!box || box.classList.contains('vcDone')) return;
            box.classList.add('vcDone');
            if (was === it.price) return;

            var s = document.createElement('s');
            s.className = 'vcWas';
            s.textContent = inr(was * it.quantity);
            box.appendChild(s);

            var off = Math.round((1 - it.price / was) * 100);
            if (off > 0) {
              var b = document.createElement('span');
              b.className = 'vcOff';
              b.textContent = off + '% off';
              box.appendChild(b);
            }
          });

          var total = inner.querySelector('.cart_total');
          if (!total || inner.querySelector('.vcRow')) return;

          var saved = mrp - cart.total_price;
          if (saved > 0) {
            var sub = document.createElement('div');
            sub.className = 'vcRow';
            sub.innerHTML = '<span>Subtotal</span><span>' + inr(mrp) + '</span>';
            total.parentNode.insertBefore(sub, total);

            var sav = document.createElement('div');
            sav.className = 'vcRow save';
            sav.innerHTML = '<span>You save</span><span>− ' + inr(saved) + '</span>';
            total.parentNode.insertBefore(sav, total);

            var lbl = total.querySelector('b');
            if (lbl) lbl.textContent = 'TOTAL';
          }
        });
      })
      .catch(function () {})
      .then(function () { painting = false; });
  }

  function enhance() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;

    /* label the note button, drop the coupon one — Avone restores both
       on every re-render, so this runs every time */
    var btns = inner.querySelectorAll('cart-option.cartFt .cftBtn');
    Array.prototype.forEach.call(btns, function (b, i) {
      if (i > 0) { b.remove(); return; }
      if (b.querySelector('.vcLabel')) return;
      var sp = document.createElement('span');
      sp.className = 'vcLabel';
      sp.textContent = 'Add a note';
      b.appendChild(sp);
      b.setAttribute('aria-label', 'Add a note');
    });
    var coupon = document.querySelector('#cartCoupon');
    if (coupon) coupon.remove();

    /* shipping line under the header */
    var head = inner.querySelector('h4');
    if (head && !inner.querySelector('.vcShip')) {
      var strip = document.createElement('div');
      strip.className = 'vcShip';
      strip.innerHTML = svg('ship') +
        '<span>Free shipping in India · Free worldwide over ₹15,000</span>';
      head.parentNode.insertBefore(strip, head.nextSibling);
    }

    var ctas = inner.querySelector('.cart__ctas');

    if (ctas && !inner.querySelector('.vcAtCheckout')) {
      var p = document.createElement('p');
      p.className = 'vcAtCheckout';
      p.textContent = 'Coupons and offers available at checkout';
      ctas.parentNode.insertBefore(p, ctas);
    }

    if (ctas && !inner.querySelector('.vcTrust')) {
      var t = document.createElement('div');
      t.className = 'vcTrust';
      t.innerHTML =
        '<div>' + svg('lock') + 'Secure<br>payments</div>' +
        '<div>' + svg('back') + '7-day<br>returns</div>' +
        '<div>' + svg('swap') + 'Hassle-free<br>exchanges</div>';
      ctas.parentNode.appendChild(t);
    }

    paint(inner);
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(enhance, 90); }

  function watch() {
    var host = document.querySelector('cart-drawer') || document.body;
    try { new MutationObserver(schedule).observe(host, { childList: true, subtree: true }); }
    catch (e) {}
    enhance();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* ═══════════ CART PAGE (/cart) ═══════════
   Append to the end of assets/vasumatis-sidebar.js
   (JavaScript only — the stylesheet goes in assets/custom.css)       */

(function () {
  if (!document.body.classList.contains('template-cart')) return;

  var productCache = {};

  function inr(paise) {
    return '₹ ' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }
  var ICON = {
    ship: '<path d="M1 6h13v10H1z"/><path d="M14 9h4l3 3.2V16h-7z"/><circle cx="6" cy="18.5" r="1.9"/><circle cx="17" cy="18.5" r="1.9"/>',
    note: '<path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9z"/><path d="M14 3v6h6M8 13h8M8 17h5"/>',
    lock: '<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/>',
    back: '<path d="M3 12a9 9 0 109-9"/><path d="M3 4v5h5"/>',
    swap: '<path d="M17 3l4 4-4 4"/><path d="M21 7H8a4 4 0 00-4 4v1"/><path d="M7 21l-4-4 4-4"/><path d="M3 17h13a4 4 0 004-4v-1"/>'
  };
  function svg(k) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICON[k] + '</svg>'; }

  function compareAt(handle, variantId) {
    if (productCache[handle]) return Promise.resolve(pick(productCache[handle], variantId));
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return pick(p, variantId); })
      .catch(function () { return 0; });
  }
  function pick(p, id) {
    if (!p || !p.variants) return 0;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === id) return p.variants[i].compare_at_price || 0;
    }
    return 0;
  }

  /* ── one-time page restructure ── */
  function layout() {
    var root = document.querySelector('cart-items.cart');
    if (!root || root.dataset.vcLayout === '1') return;
    var items   = document.querySelector('#main-cart-items');
    var summary = document.querySelector('#main-cart-footer');
    var footer  = document.querySelector('footer.cart__footer');
    if (!items || !summary || !footer) return;
    root.dataset.vcLayout = '1';

    /* count under the title */
    var title = root.querySelector('.page-title');
    var count = document.querySelector('#cartItems');
    if (title && !root.querySelector('.vcCount')) {
      var n = parseInt((count && count.textContent) || '0', 10) || 0;
      var p = document.createElement('p');
      p.className = 'vcCount';
      p.textContent = n + (n === 1 ? ' item' : ' items');
      title.parentNode.insertBefore(p, title.nextSibling);
      var rule = document.createElement('div');
      rule.className = 'vcRule';
      p.parentNode.insertBefore(rule, p.nextSibling);
    }

    /* items left, summary right */
    var grid = document.createElement('div');
    grid.className = 'vcGrid';
    var left = document.createElement('div');
    left.className = 'vcLeft';
    left.appendChild(items);

    /* note, behind a button */
    var note = footer.querySelector('cart-note');
    if (note) {
      note.hidden = true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vcNoteBtn';
      btn.innerHTML = svg('note') + 'Add a note for this order';
      btn.addEventListener('click', function () {
        note.hidden = !note.hidden;
        if (!note.hidden) { var t = note.querySelector('textarea'); if (t) t.focus(); }
      });
      left.appendChild(btn);
      left.appendChild(note);
    }

    /* the coupon box cannot apply anything — its own label says so */
    var coupon = footer.querySelector('coupon-code');
    if (coupon) coupon.remove();

    grid.appendChild(left);
    grid.appendChild(summary);
    footer.parentNode.insertBefore(grid, footer);
    footer.remove();
  }

  /* Re-runnable: Shopify replaces the summary's contents on every quantity
     change, so these have to be re-added each time rather than once. */
  function decorate() {
    var box = document.querySelector('.cartTotal');
    if (!box) return;

    if (!box.querySelector('.vcSumTtl')) {
      var h = document.createElement('p');
      h.className = 'vcSumTtl';
      h.textContent = 'Order summary';
      box.insertBefore(h, box.firstChild);
    }
    var checkout = box.querySelector('#cartCheckout');
    var tax = box.querySelector('.tax-note');
    if (!box.querySelector('.vcShip') && (tax || checkout)) {
      var ship = document.createElement('div');
      ship.className = 'vcShip';
      ship.innerHTML = svg('ship') +
        '<span>Free shipping in India · Free worldwide over ₹15,000</span>';
      box.insertBefore(ship, tax || checkout);
    }
    if (!box.querySelector('.vcAtCheckout') && checkout) {
      var off = document.createElement('p');
      off.className = 'vcAtCheckout';
      off.textContent = 'Coupons and offers available at checkout';
      box.insertBefore(off, checkout);
    }
    if (!box.querySelector('.vcTrust')) {
      var t = document.createElement('div');
      t.className = 'vcTrust';
      t.innerHTML =
        '<div>' + svg('lock') + 'Secure<br>payments</div>' +
        '<div>' + svg('back') + '7-day<br>returns</div>' +
        '<div>' + svg('swap') + 'Hassle-free<br>exchanges</div>';
      box.appendChild(t);
    }

    /* the coupon box can come back with a re-render */
    var coupon = document.querySelector('coupon-code');
    if (coupon) coupon.remove();
  }

  /* ── prices and totals, re-run after every cart update ── */
  function paint() {
    var box = document.querySelector('.cartTotal');
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        return Promise.all(cart.items.map(function (it) {
          return compareAt(it.handle, it.variant_id);
        })).then(function (cmps) {

          var rows = document.querySelectorAll('tr.cart-item');
          var mrp = 0;

          cart.items.forEach(function (it, i) {
            var was = (cmps[i] && cmps[i] > it.price) ? cmps[i] : it.price;
            mrp += was * it.quantity;

            var cell = rows[i] && rows[i].querySelector('td.ctDetails');
            if (!cell || cell.querySelector('.vcPrices')) return;
            if (!it.handle) return;
            var d = document.createElement('div');
            d.className = 'vcPrices';
            var html = '<span class="vcNow">' + inr(it.price) + '</span>';
            if (was > it.price) {
              html += '<span class="vcWas">' + inr(was) + '</span>' +
                      '<span class="vcOff">' + Math.round((1 - it.price / was) * 100) + '% off</span>';
            }
            d.innerHTML = html;
            var title = cell.querySelector('.grid-view-item__title');
            if (title) title.parentNode.insertBefore(d, title.nextSibling);
            else cell.insertBefore(d, cell.firstChild);
          });

          /* Subtotal (MRP) · You save · Total — reusing the theme's own rows */
          box = document.querySelector('.cartTotal');
          if (!box || box.querySelector('.vcRow')) return;
          var total = box.querySelector('.cart_total');
          var save  = box.querySelector('.totalSave');
          if (!total) return;

          if (mrp > cart.total_price) {
            var sub = document.createElement('div');
            sub.className = 'vcRow';
            sub.innerHTML = '<span>Subtotal</span><span>' + inr(mrp) + '</span>';
            total.parentNode.insertBefore(sub, total);
            if (save) total.parentNode.insertBefore(save, total);   /* saving above the total */
            var lbl = total.querySelector('span');
            if (lbl) lbl.textContent = 'TOTAL';
          }
        });
      })
      .catch(function () {});
  }

  function run() { layout(); decorate(); paint(); }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 80); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  function start() {
    run();
    var host = document.querySelector('cart-items.cart');
    if (host) {
      try { new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          if (ms[i].target.closest && ms[i].target.closest('.js-contents')) { schedule(); return; }
        }
      }).observe(host, { childList: true, subtree: true }); } catch (e) {}
    }
  }
})();

/* ═══════════ COLLECTION PAGE — count in title + filter badge ═══════════
   v4 · replaces v3 "COLLECTION PAGE — count, 2-line intro, filter badge"
   Lives at the end of assets/vasumatis-sidebar.js

   v4 removes the JavaScript clamping of the description. The two-line clamp
   and its more/less toggle are back to pure CSS, driven by the theme's own
   checkbox — that version was reliable, this one had nothing to fix.

   What is left here is only what CSS genuinely cannot do:
     · mirror the result count into the collection title as (67)
     · count applied filters and badge the Filter button

   If you ever see two blocks whose banners both mention COLLECTION PAGE,
   keep the higher v number and delete the other.                        */

(function () {

  /* The count.
     Never write into .flbarCount itself — that would destroy the inner
     <span class="filters-toolbar__product-count">, which is the element the
     theme's own AJAX handler updates:

        $('.filters-toolbar__product-count').html(...)

     With the span gone its selector matches nothing and the correct filtered
     number is thrown away. So: read it, mirror it into the title. */
  function syncCount() {
    var box = document.querySelector('#Collection .flbarCount');
    if (!box) return;

    var src = box.querySelector('.filters-toolbar__product-count') || box;
    var raw = (src.textContent || '').replace(/,/g, '');
    var m = raw.match(/of\s+(\d+)/i) || raw.match(/(\d+)\s*Result/i);
    if (!m) return;

    var h1 = document.querySelector('#Collection h1');
    if (!h1) return;

    var out = h1.querySelector('.vcTitleCount');
    if (!out) {
      out = document.createElement('span');
      out.className = 'vcTitleCount';
      h1.appendChild(out);
    }
    var n = parseInt(m[1], 10);
    var next = '(' + n.toLocaleString('en-IN') + ')';
    if (out.textContent !== next) out.textContent = next;
  }

  /* The price facet renders a chip even when the slider has never moved.
     Full range means no filter, so it should neither count nor show. */
  function priceUntouched() {
    var g = document.querySelector('#Collection input[name="filter.v.price.gte"]');
    var l = document.querySelector('#Collection input[name="filter.v.price.lte"]');
    if (!g || !l) return false;
    return parseFloat(g.value || 0) <= parseFloat(g.min || 0) &&
           parseFloat(l.value || 0) >= parseFloat(l.max || 0);
  }

  function apply() {
    syncCount();

    var btn = document.querySelector('#Collection .btn-filter');
    if (!btn) return;

    /* There are TWO .crFilters rows on this template — one for facets in
       main-collection.liquid, one for tags in collection-sidebar.liquid.
       Each has to be judged on its own contents. */
    var skipPrice = priceUntouched();
    var n = 0;

    Array.prototype.forEach.call(
      document.querySelectorAll('#Collection .crFilters'),
      function (row) {
        var real = 0;
        Array.prototype.forEach.call(row.querySelectorAll('.actFilter'), function (c) {
          var txt = (c.textContent || '').trim();
          c.classList.remove('vcClear', 'vcHide');
          if (/clear all|^clear$/i.test(txt)) { c.classList.add('vcClear'); return; }
          if (skipPrice && /₹/.test(txt)) { c.classList.add('vcHide'); return; }
          real++;
        });
        /* a class, not an inline style — the stylesheet sets
           display:flex !important on this row, which an inline
           display:none cannot override */
        row.classList.toggle('vcEmpty', real === 0);
        n += real;
      }
    );

    var badge = btn.querySelector('.vcCount');
    if (n > 0) {
      btn.classList.add('vcOn');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'vcCount';
        btn.appendChild(badge);
      }
      badge.textContent = n;
    } else {
      btn.classList.remove('vcOn');
      if (badge) badge.remove();
    }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 80); }

  function start() {
    apply();
    var host = document.querySelector('#Collection');
    if (host) {
      try {
        new MutationObserver(schedule).observe(host, {
          childList: true, subtree: true, characterData: true
        });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();